import { Box, Grid, makeStyles } from '@material-ui/core'
import PDFSelectionActions from './actions/PDFSelectionActions'
import PDFViewport from './pdfViewport/PDFViewport'
import PdfDocumentWrapper from '../../../PdfDocumentWrapper'
import { useCallback, useEffect, useState } from 'react'
import { UIRegionOfInterest } from '../UIRegionOfInterest'
import ScheduleColumnSelectionActions from './actions/ScheduleCoulmnSelectionActions'
import { useSelectedFilesContext } from '../../../selectedFilesProvider'
import LabelSelectionActions from './actions/labelSelectionActions'
import { ScheduleType } from '../../../../../shared/src/data/scheduleType'
import { ViewType } from '../../viewType'
import { useSelectedColumnsContext } from '../../../SelectedColumnsProvider'

const useStyles = makeStyles((theme) => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    width: 900,
  },
}))

type SelectionPDFProps = {
  selectedPageNumber: number
  setSelectedPageNumber: (pageNumber: number) => void
  focusedRegionOfInterest: UIRegionOfInterest | null
  setFocusedRegionOfInterest: (regionsOfInterests: UIRegionOfInterest | null) => void
}
export default function SelectionPDF({
  selectedPageNumber,
  setSelectedPageNumber,
  setFocusedRegionOfInterest,
  focusedRegionOfInterest,
}: SelectionPDFProps): JSX.Element {
  const classes = useStyles()
  const { files, pageToFileMap } = useSelectedFilesContext();
  const [selectedFile, setSelectedFile] = useState<PdfDocumentWrapper | null>(
    files[0],
  )
  const [isInSelectionMode, setIsInSelectionMode] = useState<boolean>(false)
  const [contentType, setContentType] = useState<ViewType[]>([])
  const [selectedLabel, setSelectedLabel] = useState<ScheduleType>(ScheduleType.SheetIndex)
  const [zoom, setZoom] = useState<number>(1)

  const getFileById = useCallback(
    (id: string): PdfDocumentWrapper | null => {
      if (!(!selectedFile || id !== selectedFile.id)) return selectedFile

      return files.find((f) => id === f.id) || null
    },
    [files, selectedFile],
  )

  useEffect(() => {
    const { file } = pageToFileMap.get(selectedPageNumber)!
    setSelectedFile(file)
    setFocusedRegionOfInterest(null);
  }, [selectedPageNumber, pageToFileMap, setFocusedRegionOfInterest])

  const { addRegionToPage } = useSelectedColumnsContext()
  const finishDrawing = (regionOfInterest: UIRegionOfInterest) => {
    addRegionToPage(selectedPageNumber, regionOfInterest)
    setIsInSelectionMode(false)
  }

  useEffect(() => {
    if (!focusedRegionOfInterest) return

    setSelectedFile(getFileById(focusedRegionOfInterest.fileId))
    setSelectedPageNumber(focusedRegionOfInterest.page)
  }, [focusedRegionOfInterest, setSelectedPageNumber, getFileById])

  return (
    <div>
      {!selectedFile ? (
        'No Selected File'
      ) : (
        <Grid className={classes.main}>
          <Box className={classes.actions}>
            <PDFSelectionActions
              numPages={pageToFileMap.size}
              selectedPageNumber={selectedPageNumber}
              setSelectedPageNumber={setSelectedPageNumber}
              zoom={zoom}
              setZoom={setZoom}
            />
            <LabelSelectionActions
              selectedLabel={selectedLabel}
              setSelectedLabel={setSelectedLabel}
            />
            <ScheduleColumnSelectionActions
              isInSelectionMode={isInSelectionMode}
              setIsInSelectionMode={setIsInSelectionMode}
              currentContentType={contentType}
              setCurrentContentType={setContentType}
            />
          </Box>
          <PDFViewport
            selectedFile={selectedFile}
            selectedPageNumber={selectedPageNumber}
            isInSelectionMode={isInSelectionMode}
            regionOfInterestContentType={contentType}
            selectedLabel={selectedLabel}
            appendSelectedRegionOfInterest={finishDrawing}
            focusedRegionOfInterest={focusedRegionOfInterest}
            zoom={zoom}
            setZoom={setZoom}
          />
        </Grid>
      )}
    </div>
  )
}
